import { useRouter } from 'next/router';

import { Button } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { useJoinCtaAssignment } from '../../hooks/use-join-cta-assignment';
import { useTrackNavigationEvent } from '../../tracking';
import { useLoginJoinModalContext } from './Context';

export const Login = () => {
  const { setModal } = useLoginJoinModalContext();
  const trackNavigationEvent = useTrackNavigationEvent();
  return (
    <Button
      variant="secondary"
      onClick={() => {
        setModal?.('login');
        trackNavigationEvent({
          feature: 'login',
          element: 'button',
          copy: 'login',
          additionalFields: {
            interface_type: 'page',
            auth_type: 'login',
          },
          product: 'onboarding',
          eventName: 'vimeo.trigger_auth_flow',
          version: 2,
        });
      }}
      size={{ base: 'sm', sm: 'md' }}
    >
      {translate('Log in')}
    </Button>
  );
};

export const Join = () => {
  const trackNavigationEvent = useTrackNavigationEvent();
  const { ctaText, ctaTextTranslated } = useJoinCtaAssignment();
  const router = useRouter();

  return (
    <Button
      variant="primary"
      onClick={() => {
        trackNavigationEvent({
          feature: 'join',
          element: 'button',
          copy: ctaText,
          additionalFields: {
            interface_type: 'page',
            auth_type: 'join',
          },
          product: 'onboarding',
          eventName: 'vimeo.trigger_auth_flow',
          version: 2,
        });
        router.push('/join');
      }}
      size={{ base: 'sm', sm: 'md' }}
    >
      {ctaTextTranslated}
    </Button>
  );
};
